/**
 * @file index.tsx
 *
 * @fileoverview Shows a form centered on the page.
 */
import React from "react";
import { FormHTMLAttributes } from "react";
import styles from "./centerForm.module.scss";

/**
 * Places the form on the center of the page. Useful for login or register
 * pages where what we want the user to do is very clear.
 * It makes the main action and form very clear. Shouldn't be used for very long forms.
 */

export type CenterFormProps = FormHTMLAttributes<any> & {
  /**
   * A specific minimum width for the form.
   */
  minWidth?: string;
  /**
   * The form contents.
   */
  children: React.ReactNode;
};

export default function CenterForm({
  children,
  minWidth,
  ...props
}: CenterFormProps) {
  return (
    <form
      className={styles.centerForm}
      style={{
        minWidth: minWidth ? minWidth : "300px",
      }}
      {...props}
    >
      {children}
    </form>
  );
}
export { CenterForm };
